module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-Bold.259fdd2f.woff";